import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import NewWorkflow from './new-workflow.svg'
import IntegrationsMob from './integrations-mob.svg'
import IntegrationsDesk from './integrations-desk.svg'
import ArrowMob from './arrow-mobile.svg'
import ArrowDesk from './arrow-desktop.svg'
import classes from './WorkflowAutomationToolsFramework.module.scss'

export const WorkflowAutomationToolsFramework = () => {
  return (
    <div className={classes.wrapper}>
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        Connector framework flexible enough for all your needs
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        Our open connector framework lets you access data and metadata in every
        external API in a consistent way.
      </Text>
      <div className={classes.wrap}>
        <img
          src={NewWorkflow.src}
          className={classes.imageFirst}
          alt='Connector framework flexible enough for all your needs'
          width={270}
          height={134}
          loading='lazy'
        />
        <Picture
          className={classes.arrow}
          mobSvg={ArrowMob.src}
          deskSvg={ArrowDesk.src}
          deskBreakpoint={992}
          alt=''
          width={93}
          height={146}
          lazyLoad
          ariaHidden
        />
        <div className={classes.content}>
          <Text as={'span'} size={'md'} className={classes.contentCaption}>
            Connector Framework
          </Text>
          <div className={classes.contentInner}>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Authentication</span>
            </div>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Operations</span>
            </div>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Data Collections</span>
            </div>
            <div className={classes.contentBlock}>
              <span className={classes.contentSubtitle}>Events</span>
            </div>
          </div>
        </div>
        <Picture
          className={classes.imageLast}
          mobSvg={IntegrationsMob.src}
          deskSvg={IntegrationsDesk.src}
          deskBreakpoint={992}
          alt='Integrations'
          lazyLoad
        />
      </div>
      {/* <Link
        type='secondary'
        className={classes.link}
        href={CONNECTOR_DOCS_LINK}
      >
        Learn more about connector framework
      </Link> */}
    </div>
  )
}
